import { Button, Checkbox, Flex, Form, Input, Modal, Radio, Upload } from 'antd'
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../../../../../../store/reducers/assignments.reducer'
import { ASSIGNMENT_TYPES } from '../../../../../../../constants/assignment-types'
import { useForm } from 'antd/es/form/Form'
import { useAutoFocusFirstInput } from '../../../../../../../../hooks/useAutoFocusFirstInput'

const { Dragger } = Upload

const CreateComputerScienceAssignmentForm = ({ submissionsFileList, setSubmissionsFileList, uploadAssignment }) => {
    const [form] = useForm()
    useAutoFocusFirstInput()

    const [isWaitingForFileToUpload, setIsWaitingForFileToUpload] = useState(false)

    useEffect(() => {
        return () => setSubmissionsFileList([])
    }, [])

    const draggerProps = {
        name: 'file',
        accept: '.zip',
        multiple: false,
        listType: 'picture',
        maxCount: 1,
        fileList: submissionsFileList,
        beforeUpload: file => {
            if (submissionsFileList.length) {
                Modal.confirm({
                    title: 'Confirm replacement',
                    icon: <ExclamationCircleOutlined />,
                    content: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: `You have already selected <code>${submissionsFileList[0].name}</code> file. Are you sure that you want to replace it?`,
                            }}
                        />
                    ),
                    okText: 'Confirm',
                    onOk() {
                        setSubmissionsFileList([file])
                    },
                    cancelText: 'Cancel',
                })
            } else {
                setSubmissionsFileList([file])
            }
            return false
        },
        onRemove() {
            setSubmissionsFileList([])
        },
    }

    const handleSubmit = async values => {
        setIsWaitingForFileToUpload(true)
        await uploadAssignment(values.name, values.type, values.requireTrainset)
        setIsWaitingForFileToUpload(false)
    }

    const typeOptions = [
        { label: ASSIGNMENT_TYPES.MODEL.name, value: ASSIGNMENT_TYPES.MODEL.value },
        { label: ASSIGNMENT_TYPES.ASSIGNMENT.name, value: ASSIGNMENT_TYPES.ASSIGNMENT.value },
    ]

    return (
        <Form
            name='create-computer-science-assignment-form'
            onFinish={handleSubmit}
            autoComplete='off'
            form={form}
            layout='vertical'
            requiredMark={false}
        >
            <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Please, enter the name' }]}>
                <Input placeholder='Name' />
            </Form.Item>
            <Form.Item
                name='submissionsFiles'
                valuePropName='submissionsFiles'
                label='File'
                rules={[
                    {
                        message: 'Please, select ZIP file with submissions',
                        validator: () => {
                            if (submissionsFileList.length) {
                                return Promise.resolve()
                            } else {
                                return Promise.reject('Some message here')
                            }
                        },
                    },
                ]}
            >
                <Dragger {...draggerProps}>
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>Click or drag ZIP with submissions to this area</p>
                </Dragger>
            </Form.Item>
            <Flex justify='space-between' align='end'>
                <Form.Item name='type' label='Type' initialValue={ASSIGNMENT_TYPES.MODEL.value}>
                    <Radio.Group options={typeOptions} optionType='button' />
                </Form.Item>
                <Form.Item name='requireTrainset' valuePropName='checked' initialValue={false}>
                    <Checkbox>Require test set</Checkbox>
                </Form.Item>
            </Flex>
            <Form.Item>
                <Button type='primary' htmlType='submit' block loading={isWaitingForFileToUpload}>
                    Create
                </Button>
            </Form.Item>
        </Form>
    )
}

const mapState = ({ assignments }) => {
    return {
        submissionsFileList: assignments.submissionsFileList,
    }
}

const mapDispatch = dispatch => {
    return {
        setSubmissionsFileList(value) {
            dispatch(actions.setSubmissionsFileList(value))
        },
        uploadAssignment(name, type, requireTrainset) {
            return dispatch(actions.uploadAssignment(name, type, requireTrainset))
        },
        setAssignmentName(value) {
            dispatch(actions.setAssignmentName(value))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateComputerScienceAssignmentForm)
